import { OrderStatus } from "@/services/marketplace/order";
import { fetchOrderStatusCount } from "@/services/marketplace/order/sales";
import { readonly } from "vue";

const count = ref(0);
const isSomethingNew = computed(() => count.value > 0);

const CheckInterval = 120000;
let timer: ReturnType<typeof setInterval> | null = null;

export function useNewSaleCheck() {
  const startAutocheck = () => {
    if (timer !== null) {
      return;
    }

    check();
    timer = setInterval(() => check(), CheckInterval);
  };

  const stopAutocheck = () => {
    if (timer !== null) {
      clearInterval(timer);
    }
  };

  const clear = () => {
    count.value = 0;
  };

  const check = async () => {
    const result = await fetchOrderStatusCount();
    count.value = result.statusCounts[OrderStatus.Packaging];
  };

  return {
    isSomethingNew: readonly(isSomethingNew),
    count: readonly(count),

    startAutocheck,
    stopAutocheck,

    clear,
  };
}
